import React, { useState } from "react";
import { Template } from "../../Components/Template/template";

export const UserPage = () => {

  return <Template>
    <div className="flex h-[100%] w-full">
      <div id="div-body" className="w-full mr-2 mb-2 h-full max-sm:ml-0 ml-[310px] mt-[70px] ml-30 transition-all duration-500">
        <div className="w-full h-auto bg-red-200">
          
        


        </div>
      </div>
    </div>
  </Template>
}